import {FormikConfig} from 'formik';
import _ from 'lodash';

import utils from '@utils';

export const main: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  if (values.toSentDatetime) {
    utils.validate.vaildDate(values, errors, 'toSentDatetime');
  }
  if (values.fromSentDatetime) {
    utils.validate.vaildDate(values, errors, 'fromSentDatetime');
  }
  if (
    utils.date.validateFormat(values.toSentDatetime, 'YYYY/MM/DD') &&
    utils.date.validateFormat(values.fromSentDatetime, 'YYYY/MM/DD')
  ) {
    if (
      !utils.date.isAfterDate(values.toSentDatetime, values.fromSentDatetime)
    ) {
      errors.fromSentDatetime = '正しい日付を入力してください';
    }
  }

  return errors;
};

export const create: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  if (
    !values.isEmailSending &&
    !values.isSMSSending &&
    !values.isConnectSending
  ) {
    errors.isEmailSending = '通知手段は必須選択です';
  }
  if (_.isNull(values.disasterType)) {
    errors.disasterType = '災害は必須選択です';
  }
  if (_.isNull(values.prefecture)) {
    errors.prefecture = '地域は必須選択です';
  }
  if (!values.message) {
    errors.message = 'メッセージは必須入力です';
  }

  return errors;
};

export const resend: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  if (
    !values.isEmailSending &&
    !values.isSMSSending &&
    !values.isConnectSending
  ) {
    errors.isEmailSending = '通知手段は必須選択です';
  }

  return errors;
};
